
export default async function ({ store, redirect,app,route }) {
    return redirect('https://my.linkcard.app'+route.path)
}

